"use client"
/* */
import { isValidElement } from 'react';
import { deepFind, deepForEach } from 'react-children-utilities';

const isOfType = (c, searchType) => {
  if (!isValidElement(c)) {
    return false;
  }
  if (typeof searchType === "string") {
    if (typeof c.type === "string") {
      return c.type === searchType;
    }
    return false;
  }
  return c.type === searchType;
};
const deepFindOfType = (children, searchType) => deepFind(children, (c) => isOfType(c, searchType));
const deepFilterByType = (children, searchType) => {
  const result = [];
  deepForEach(children, (c) => {
    if (isOfType(c, searchType)) {
      result.push(c);
    }
  });
  return result;
};

export { deepFilterByType, deepFindOfType };
//# sourceMappingURL=deepFindOfType.mjs.map
